jQuery(document).ready(function ($) {
  // add listeners on home page for giving header solid background on mouse enter, remove on leave
  const headerOuter = document.querySelector("body.home .site-header");

  if (headerOuter) {
    headerOuter.addEventListener("mouseenter", function (e) {
      if (!this.classList.contains("active")) this.classList.add("active");
    });

    headerOuter.addEventListener("mouseleave", function (e) {
      if (this.classList.contains("active")) this.classList.remove("active");
    });
  }

  let theTim;

  // handle adding overlay when mega menu open
  $(".top-level.menu-item-has-children").on("mouseenter", function () {
    document.body.classList.add("mega-menu-active");

    if (theTim) {
      clearTimeout(theTim);
    }
    $(".site-header").addClass("has-mouse");
  });

  // listener for hover leave on top level menu item with children
  $(".top-level.menu-item-has-children").on("mouseleave", function () {
    document.body.classList.remove("mega-menu-active");

    // only remove the
    theTim = setTimeout(function () {
      $(".site-header").removeClass("has-mouse");
    }, 700);
  });
});
